/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Billing period, required if billing_type is recurring
 */
export const ProductRequestBillingPeriod = {
  Once: "once",
  EveryMonth: "every-month",
  EveryThreeMonths: "every-three-months",
  EverySixMonths: "every-six-months",
  EveryYear: "every-year",
} as const;
/**
 * Billing period, required if billing_type is recurring
 */
export type ProductRequestBillingPeriod = ClosedEnum<
  typeof ProductRequestBillingPeriod
>;

/** @internal */
export const ProductRequestBillingPeriod$inboundSchema: z.ZodNativeEnum<
  typeof ProductRequestBillingPeriod
> = z.nativeEnum(ProductRequestBillingPeriod);
/** @internal */
export const ProductRequestBillingPeriod$outboundSchema: z.ZodNativeEnum<
  typeof ProductRequestBillingPeriod
> = ProductRequestBillingPeriod$inboundSchema;
